// This file contains constants for static assets (images, icons, etc.) used in the application.

export const IMAGES = {
  appLogo: '/assets/images/app_logo.svg',
  /** Same logo with dark lettering, for light surfaces. */
  appLogoDark: '/assets/images/app_logo_dark.svg',
  logo: '/assets/images/logo.png',
  loginHero: '/assets/images/login_right.png',
  menuCardTrio: '/assets/images/menu_card_trio.png',
  menuTest1: '/assets/images/menu_test1.png', // Ember & Olive — seasonal menu (sample)
  menuTest2: '/assets/images/menu_test2.png', // The Verdant Table — brunch (sample)
  menuTest3: '/assets/images/menu_test3.png', // Noir Spice House — cocktails (sample)
  // 540×720 copies of the menu tests for cards (~¼ the file size). Regenerate with: sips -Z 720 <src> --out thumbs/<name>
  menuTest1Thumb: '/assets/images/thumbs/menu_test1.png',
  menuTest2Thumb: '/assets/images/thumbs/menu_test2.png',
  menuTest3Thumb: '/assets/images/thumbs/menu_test3.png',
  // Create-project page artwork (720px copy of project_menu_placeholder.png)
  projectMenuPlaceholder: '/assets/images/thumbs/project_menu_placeholder.png',
} as const
